import {urls, api} from '@/api'
import * as types from '@/store/mutation-types'

const getInitialState = () => ({
  publications: [],
  page: 1,
  per_page: 25,
  totalPages: null,
  totalPubs: null,
  aggregations: {}
})

const state = getInitialState()

const actions = {
  cleanState: ({commit}) => {
    commit(types.FAV_RESET_STATE)
    return Promise.resolve()
  },

  fetchPublications: ({commit, state, rootState}, params = {}) => {
    params.favorites = rootState.user.id

    if (params.page) commit(types.FAV_SET_PAGE, params.page)
    else params.page = state.page
    params.per_page = state.per_page

    return api.get(urls.publicationSearch, { params })
      .then(({data}) => {
        const aggregations = Array.isArray(data.aggregations) ? {} : data.aggregations

        commit(types.FAV_SET_PUBLICATIONS, data.data)
        commit(types.FAV_SET_TOTAL_PAGES, data.meta.pagination.total_pages)
        commit(types.FAV_SET_TOTAL_PUBS, data.meta.pagination.total)
        commit(types.FAV_SET_AGGREGATIONS, aggregations)
      })
      .catch(err => {})
  },

  removeFavorite: ({commit, state}, pubId) => {
    commit(types.FAV_SET_PUBLICATIONS, state.publications.filter(({id}) => id !== pubId))

    return api.delete(`${urls.favorites}/${pubId}`)
  },

  setPage: ({commit}, page) => { commit(types.FAV_SET_PAGE, page) },
}

const mutations = {
  [types.FAV_SET_PUBLICATIONS] (state, publications) {
    state.publications = publications || []
  },

  [types.FAV_SET_AGGREGATIONS] (state, aggregations) {
    state.aggregations = aggregations || {}
  },

  [types.FAV_RESET_STATE] (state) {
    Object.assign(state, getInitialState())
  },

  [types.FAV_SET_PAGE] (state, page) {
    state.page = parseInt(page)
  },

  [types.FAV_SET_TOTAL_PAGES] (state, total) {
    state.totalPages = total
  },

  [types.FAV_SET_TOTAL_PUBS] (state, total) {
    state.totalPubs = total
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/favorites.js